var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('h1',{staticClass:"app-private-title"},[_vm._v(_vm._s(`${_vm.title}:`))]),_c('h1',{staticClass:"app-private-subtitle ml-1"},[_vm._v(_vm._s(_vm.subtitle))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }